/*
 * File: retrier.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-02 05:37:52
 * Modified By: Val Liu
 * -----
 */

export class Retrier {
    private callback: any;
    private timer: any;
    private interval: number;
    constructor(callback: any, interval: number) {
        this.callback = callback;
        this.interval = interval;
    }
    public start() {
        if (this.timer) return;
        this.timer = setInterval(this.callback, this.interval);
    }
    public restart() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        this.start();
    }
    public stop() {
        if (!this.timer) return;
        clearInterval(this.timer);
        this.timer = null;
    }
    public async do(o?) {
        await this.callback(o);
    }
}
